export default __webpack_public_path__ + "static/media/collect.9b8395af.svg";